// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3twgW","top":"styles_top__4zbas","left":"styles_left__1PvUo","description":"styles_description__2j4GU"};